import { useMutation, useQueryClient } from '@tanstack/react-query';
import useApiClient from '../../Shared/services/api';
import { updateArtEventStatus } from '../service/service';
import {
  UpdateArtEventRequest,
  UpdateArtEventResponse,
} from '../interfaces/editArtEventInterfaces';
import { ArtEventEndpointQueryKeys } from '../../Shared/constants/artEvent/endpoints';

export const useUpdateArtEventMutation = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<
    UpdateArtEventResponse | null,
    Error,
    UpdateArtEventRequest
  >({
    mutationFn: (data: UpdateArtEventRequest) =>
      updateArtEventStatus(api, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ArtEventEndpointQueryKeys.GET_ART_EVENTS],
      });
    },
  });
};
